<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

	const LANGUAGE_TO_ICON_NAME: Record<string, IconName> = {
		DE: 'germanFlag',
		EN: 'britishFlag',
		FR: 'frenchFlag',
		IT: 'italianFlag',
		ES: 'spanishFlag',
		TR: 'turkishFlag',
		GR: 'greekFlag'
	}

	interface Props {
		supportedLanguages?: string[]
	}

	let { supportedLanguages = [] }: Props = $props()
</script>

<div class="languages-container flex items-center gap-2">
	{#each supportedLanguages as lang}
		{@const iconName = LANGUAGE_TO_ICON_NAME[lang]}
		<Icon name={iconName} />
	{/each}
</div>
